import React from "react";
import { connect } from "react-redux";
import { Route } from "react-router-dom";
import Mainlayout from "../layouts/mainLayout";
import AdminLayout from "../layouts/adminLayout";

const PublicRouteNoAccess = ({ component: Component, ...rest }) => {
  console.log({ component: Component, ...rest });
  return (
    <Route
      {...rest}
      component={(props) => {
        if (rest.fulllayout) {
          return (
            <Mainlayout>
              <Component {...props} />{" "}
            </Mainlayout>
          );
        } else {
          return (
            <AdminLayout props={props}>
              <Component {...props} />{" "}
            </AdminLayout>
          );
        }
      }}
    />
  );
};

export default PublicRouteNoAccess;
